import { createStore } from 'vuex'
import main from './main'
import sideMenu from './side-menu'
import pages from './pages'

const store = createStore({
  modules: {
    main,
    sideMenu,
    pages
  }
})

export function useStore() {
  return store
}

export default store
